import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { QuestionIcon } from 'foundations-assets/icons/components/QuestionIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { REMOVE } from '../types';
import { isReloading } from '../hooks/useFetchBatchResolverWithReload';
import FileSkeleton from '../FileSkeleton';
import FileIconWrapper from '../FileIconWrapper';
import FileItemLayout from '../components/FileItemLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const unresolvedFileValueMessage = /*#__PURE__*/_jsx(FormattedMessage, {
  message: 'customerDataProperties.PropertyInputFilesV2.unresolvedFileValue'
});
const isUrl = fileId => /^https?:\/\//i.test(fileId);
const FileValuesUnresolvedList = ({
  isEditDisabled,
  missingFileReferences,
  onFileAction,
  showRemoveAction,
  status
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: missingFileReferences.map(fileId => {
      const maybeUrl = isUrl(fileId);
      return /*#__PURE__*/_jsx(TFlex, {
        direction: "column",
        "data-test-id": "file-unresolved-value-list",
        marginBlockEnd: "50",
        children: status && isReloading(status) ? /*#__PURE__*/_jsx(FileSkeleton, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TFlex, {
            children: /*#__PURE__*/_jsx(TruncateString, {
              children: /*#__PURE__*/_jsx(FileItemLayout, {
                icon: /*#__PURE__*/_jsx(QuestionIcon, {
                  color: "icon-tertiary-default",
                  size: "400"
                }),
                labelContent: maybeUrl ? /*#__PURE__*/_jsx(Link, {
                  external: true,
                  href: fileId,
                  children: fileId
                }) : fileId,
                actions: showRemoveAction ? /*#__PURE__*/_jsx(FileIconWrapper, {
                  children: /*#__PURE__*/_jsx(IconButton, {
                    size: "small",
                    use: "link",
                    onClick: () => onFileAction({
                      action: REMOVE,
                      fileId
                    }),
                    "data-test-id": "file-attachment-with-error-remove-icon",
                    disabled: isEditDisabled,
                    children: /*#__PURE__*/_jsx(RemoveIcon, {
                      size: "100",
                      "data-test-id": "file-unresolved-value-remove-icon"
                    })
                  })
                }) : null
              })
            })
          }), !maybeUrl && /*#__PURE__*/_jsx(Small, {
            use: "error",
            weight: "medium",
            children: unresolvedFileValueMessage
          })]
        })
      }, fileId);
    })
  });
};
export default FileValuesUnresolvedList;